import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetSubscriptionsUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {UseCase} deps.userRepository
   */
  constructor({userRepository, subscriptionsParamsRequestFactory}) {
    super({})

    this._userRepository = userRepository
    this._subscriptionsParamsRequestFactory = subscriptionsParamsRequestFactory
  }

  @inlineError
  async execute({subscriptionType = '', userId, token}) {
    const subscriptionsParams = this._subscriptionsParamsRequestFactory({subscriptionType, userId, token})

    const [error, userSubscriptions] = await this._userRepository.getSubscriptions({subscriptionsParams})
    if (error) {
      throw error
    }

    return userSubscriptions.toJSON()
  }
}
